//for All 
export const PRODUCT_REQUEST="PRODUCT_REQUEST"
export const PRODUCT_FAILURE="PRODUCT_FAILURE"

export const POST_PRODUCT_SUCCESS="POST_PRODUCT_SUCCESS"
export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS"
export const PATCH_PRODUCT_SUCCESS="PATCH_PRODUCT_SUCCESS"


//Cart
export const ADD_PRODUCT_SUCCESS="ADD_PRODUCT_SUCCESS"
export const ITEM_REMOVE_SUCCESS='ITEM_REMOVE_SUCCESS'